// App translations
import { appInitializerFactory, HttpLoaderFactory } from './app-translations';
var ɵ0 = HttpLoaderFactory, ɵ1 = appInitializerFactory;
/**
 * Root module
 */
var AppModule = (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0, ɵ1 };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/app.module.ts.pre-build-optimizer.js